import RupeeSymbol from './RupeeSymbol';

export default RupeeSymbol;
